/** Helper `apiCall<T>`: ejecuta cualquier request sobre la instancia axios y normaliza la respuesta en `ApiResponse<T>` (data o mensaje de error de red/backend). */
import axiosInstance from "./axiosInstance";
import { ApiResponse } from "@/types";

export async function apiCall<T>(
  requestConfig: Parameters<typeof axiosInstance.request>[0]
): Promise<ApiResponse<T>> {
  try {
    const response = await axiosInstance.request(requestConfig);
    return { success: true, data: response.data as T };
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: unknown } };
    return {
      success: false,
      error: axiosError.response ? axiosError.response.data : "Error de red",
    };
  }
}
